import React from 'react'

import { Combobox } from '@headlessui/react'
import { clsx } from 'clsx'

import { Hotkey } from '@tribeplatform/react-ui-kit/Hotkey'
import { SvgIcon, type SvgIconName } from '@tribeplatform/react-ui-kit/Icon'

import { type CommandBarActionType } from '../../types.js'

interface Props {
  action: CommandBarActionType
  hideHotkey?: boolean
}

export const CommandBarActionItem = ({ action, hideHotkey }: Props) => {
  return (
    <Combobox.Option
      key={action.name}
      value={action}
      className={({ active }) =>
        clsx(
          'flex cursor-pointer select-none items-center px-3 py-2 rounded-md',
          active && 'bg-surface-subdued',
        )
      }
    >
      <SvgIcon
        name={(action?.icon as SvgIconName) || 'arrow-right'}
        size="lg"
        className="flex-none"
      />

      <span className="ms-3 flex-auto truncate">{action.name}</span>
      {!hideHotkey && action?.hotkey && <Hotkey>{action?.hotkey}</Hotkey>}
    </Combobox.Option>
  )
}
